import { render, staticRenderFns } from "./pay-result.vue?vue&type=template&id=6d7343cf&scoped=true&"
import script from "./pay-result.vue?vue&type=script&lang=js&"
export * from "./pay-result.vue?vue&type=script&lang=js&"
import style0 from "./pay-result.vue?vue&type=style&index=0&id=6d7343cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7343cf",
  null
  
)

export default component.exports